import { render, staticRenderFns } from "./ModalLayout.vue?vue&type=template&id=21e0b35a"
import script from "./ModalLayout.vue?vue&type=script&lang=js"
export * from "./ModalLayout.vue?vue&type=script&lang=js"
import style0 from "./ModalLayout.vue?vue&type=style&index=0&id=21e0b35a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports